/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';

import TrackListRowAccordionDetails from './TrackListRowAccordionDetails';
import TrackListRowAccordionUsage from './TrackListRowAccordionUsage';
import TrackListRowAccordionLicenseComponents from './TrackListRowAccordionLicenseComponents';
import styles from './styles.module.scss';
import type {
  SimplifiedTrack,
  SimplifiedMedia,
  Usage,
  SaveUsageParams,
  MergedLicenseComponent,
  Translate,
} from 'types';

export type TabId = 'DETAILS' | 'NOTES' | 'USAGE' | 'LICENSE_COMPONENTS';

type Props = {
  track: SimplifiedTrack,
  components?: MergedLicenseComponent[],
  selectedComponents?: string[],
  onComponentCheckboxClick?: (componentId: string) => mixed,
  onComponentHeaderCheckboxClick?: () => mixed,
  usage?: Usage,
  isReadOnlyUsage?: boolean,
  hasUsage?: boolean,
  medias?: SimplifiedMedia[],
  onMediaClick?: (media: SimplifiedMedia) => mixed,
  isWorklistItem?: boolean,
  onCreateProduction?: () => mixed,
  onSaveUsage?: (params: SaveUsageParams) => any,
  onAskQuotationForComponents?: (components: MergedLicenseComponent[]) => mixed,
  onBuyComponents?: (components: MergedLicenseComponent[]) => mixed,
  selectedTabId?: TabId | null,
  isLoading?: boolean,
  t: Translate,
};

type State = {
  visibleTabId: TabId,
};

class TrackListRowAccordion extends React.PureComponent<Props, State> {
  state = {
    visibleTabId: 'DETAILS',
  };

  constructor(props) {
    super(props);
    const { selectedTabId } = props;
    this.state = {
      visibleTabId: this._isTabAvailable(selectedTabId) ? selectedTabId : 'DETAILS',
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedTabId } = this.props;
    if (selectedTabId !== prevProps.selectedTabId && this._isTabAvailable(selectedTabId)) {
      this.setState({ visibleTabId: selectedTabId });
    }
  }

  _isTabAvailable = (tabId?: TabId | null) => {
    const { hasUsage, components } = this.props;
    if (tabId == null) {
      return false;
    }
    if (tabId === 'USAGE' && !hasUsage) {
      return false;
    }
    if (tabId === 'LICENSE_COMPONENTS' && (!hasUsage || components == null)) {
      return false;
    }
    return true;
  };

  _renderTabTitle = (tabId: TabId, label: string) => {
    switch (tabId) {
      case 'DETAILS':
        break;
      case 'USAGE':
        if (!this.props.usage) {
          return null;
        }
        break;
      // case 'NOTES':
      //   if (!(this.props.usage && this.props.usage.notes)) {
      //     return null;
      //   }
      //   break;
      case 'LICENSE_COMPONENTS':
        if (this.props.components === null || this.props.components === undefined) {
          return null;
        }
        break;
      default:
        break;
    }
    const isActive = this.state.visibleTabId === tabId;
    return (
      <div
        className={isActive ? styles.tabTitleActive : styles.tabTitle}
        onClick={() => this.setState({ visibleTabId: tabId })}
      >
        {label}
      </div>
    );
  };

  _handle;

  render() {
    const {
      track,
      medias,
      hasUsage,
      usage,
      isReadOnlyUsage = false,
      components,
      onComponentCheckboxClick,
      onComponentHeaderCheckboxClick,
      selectedComponents,
      onSaveUsage,
      onMediaClick,
      isWorklistItem,
      onCreateProduction,
      onAskQuotationForComponents,
      onBuyComponents,
      isLoading = false,
      t,
    } = this.props;
    const { visibleTabId } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.tabTitles}>
          {this._renderTabTitle('DETAILS', t('DETAILS'))}
          {!!hasUsage && this._renderTabTitle('USAGE', t('USAGE'))}
          {/* {this._renderTabTitle('NOTES', t('NOTES'))} */}
          {this._renderTabTitle('LICENSE_COMPONENTS', t('LICENSE_COMPONENTS'))}
        </div>
        <div className={styles.tabContent}>
          {visibleTabId === 'DETAILS' && (
            <TrackListRowAccordionDetails
              track={track}
              medias={medias}
              onMediaClick={onMediaClick}
            />
          )}
          {!!hasUsage && usage && visibleTabId === 'USAGE' && (
            <TrackListRowAccordionUsage
              usage={usage}
              isReadOnlyUsage={isReadOnlyUsage}
              onSave={onSaveUsage}
              isWorklistItemUsage={isWorklistItem}
              onCreateProduction={onCreateProduction}
              track={track}
              isLoading={isLoading}
            />
          )}
          {components != null && visibleTabId === 'LICENSE_COMPONENTS' && (
            <TrackListRowAccordionLicenseComponents
              components={components}
              onComponentCheckboxClick={onComponentCheckboxClick}
              onComponentHeaderCheckboxClick={onComponentHeaderCheckboxClick}
              selectedComponents={selectedComponents}
              track={track}
              onAskQuotation={onAskQuotationForComponents}
              onBuyComponents={onBuyComponents}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(TrackListRowAccordion);
